<template>
	<div :class="`c-resource-links ${(resourceLinks.length === 0) ? 'c-resource-links--empty' : ''} t-margin-top-s t-margin-right-s t-margin-left-s`">
		<template v-for="(link, index) in resourceLinks">
			<resource-link
				:text="link.attributes.text" 
				:link="link.attributes.link" 
				:process-id="processId"
				:process-type="processType"
				:resource-id="resourceId"
				:resource-link-id="link.id"
				:index="index + 1"
				:sortIndex="getSortIndexForResourceLink(resourceLinks, link)"
				:sortIndexes="getSortIndexes(resourceLinks)"
				@editResourceLink="editResourceLink"
				@sortResourceLinks="sortResourceLinks"
				@deleteResourceLink="deleteResourceLink">
			</resource-link>
		</template>
		<can i="manage" :a="processType">
			<div>
				<button v-if="!showCreate" class="c-button c-button--secondary" @click.prevent="toggleShowCreate">Lägg till länk</button>			
			</div>
			<div>
				<resource-link 
					mode="create" 
					:process-id="processId"
					:resource-id="resourceId" 
					v-if="showCreate"
					@createResourceLink="createResourceLink"
					@toggleShowCreate="toggleShowCreate">
				</resource-link>
			</div>
		</can>
	</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import ResourceLink from './../resource-link/ResourceLink.vue';
export default {
    name: 'ResourceLinks',
    props: {
		processId: {
            type: String,
            default: '0'
		},
		processType: {
			type: String,
			default: ''
		},
		resourceId: {
			type: String,
			default: ''	
		},
		resourceLinks: {
			type: Array,
			default: () => []
		},
		parentMode: {
			type: String,
			default: 'view'
		},
		showCreate: {
			type: Boolean,
			default: false
		},
    },
	components: { ResourceLink },
    methods: {
		getSortIndexes(resourceLinks) {
			const result = resourceLinks.length > 1 && resourceLinks.map(link => link.attributes.sortIndex).some(y => y !== 0) 
				? resourceLinks.map(link => link.attributes.sortIndex).sort(function(a, b){return a - b}) 
				: resourceLinks.map((r, i) => i);	
			return result;
		},
		getSortIndexForResourceLink(resourcesLinks, resourceLink){
			const index = resourcesLinks.length > 1 && resourcesLinks.map(link => link.attributes.sortIndex).some(y => y !== 0)
				? resourceLink.attributes.sortIndex
				: resourcesLinks.indexOf(resourceLink);
			return index;
		},
		sortResourceLinks({ id, sortIndex }){
			this.$emit('sortResourceLinks', { id, sortIndex });
        },
		toggleShowCreate() {
			this.$emit('setShowCreate', !this.showCreate);
		},
		createResourceLink(resourceLink) {
			this.$emit('createResourceLink', resourceLink);
		},
		deleteResourceLink(resourceLinkId) {
			this.$emit('deleteResourceLink', resourceLinkId);
		},
		editResourceLink({resourceLinkId, text, link}) {
			this.$emit('editResourceLink', {resourceLinkId, text, link});
		},
    },
};
</script>
